<template>
  <b-modal :id="`change-trip-status-model${id ? `-${id}` : ''}`">
    <div class="p-3">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="assign-section-title">{{ $t('change-status') }}</div>
        <img
          :src="require('@/assets/images/icons/close-icon.svg')"
          alt=""
          class="cursor-pointer"
          @click="closeModel"
        />
      </div>
      <hr />
      <form @submit.prevent="Submit">
        <b-alert :show="error && error.length ? true : false" variant="danger">
          <div v-if="Array.isArray(error)">
            <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
              {{ error_text }}
            </div>
          </div>
          <div v-else>
            <div v-html="error || '&nbsp;'"></div>
          </div>
        </b-alert>
        <div style="margin-bottom: 20px">
          <p class="reservation-info">{{ $t('reservation') }} #{{ reservationID }}</p>
        </div>
        <div class="mt-2 mb-5">
          <p class="reservation-status-options">
            {{ $t('reservation-status') }}
          </p>
          <div>
            <b-form-radio-group
              v-model="selected"
              :options="statusOptions"
              :checked="status"
              name="status"
              class="d-flex flex-wrap gap-3"
              id="reservation-status-options"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="hr-border"></div>
        <div class="d-flex justify-content-end">
          <div>
            <base-button
              class="primary mx-2"
              variant="primary"
              type="submit"
              id="reservation-status-save-btn"
              :loading="loading"
              cus_style="max-width=max-width:135px; !important"
              :disabled="originSelectedStatus === selected"
            >
              {{ $t('save') }}
            </base-button>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import NewReservationService from '@/services/new-reservation.service'

export default {
  name: 'change-trip-status-model',
  components: {},
  props: ['name', 'newName', 'id', 'status', 'paymentMethod'],
  emits: ['refreshData'],
  data() {
    return {
      loading: false,
      selected: '',
      originSelectedStatus: '',
      options: [
        { text: this.$t('quotation'), value: 'quotation' },
        { text: this.$t('sales-order'), value: 'sales-order' },
        { text: this.$t('canceled'), value: 'cancelled' },
      ],
      error: null,
    }
  },
  computed: {
    reservationID() {
      return this.$route.params.id || this.id
    },
    statusOptions() {
      let statusOptions
      switch (this.originSelectedStatus) {
        case 'quotation': {
          if (this.paymentMethod === 'Debit') {
            statusOptions = [{ text: this.$t('quotation'), value: 'quotation' }]
            statusOptions.push(...this.options.filter((option) => option.value === 'cancelled'))
            break
          } else {
            statusOptions = this.options
            break
          }
        }
        case 'sales-order': {
          statusOptions = this.options.filter((option) => option.value !== 'quotation')
          break
        }
        case 'cancelled': {
          statusOptions = this.options.filter((option) => option.value === 'cancelled')
          break
        }
        case 'waiting-for-approval': {
          statusOptions = [{ text: this.$t('waiting-for-approval'), value: 'waiting-for-approval' }]
          statusOptions.push(...this.options.filter((option) => option.value === 'cancelled'))
          break
        }
        case 'draft-quotation': {
          statusOptions = [{ text: this.$t('draft-quotation'), value: 'draft-quotation' }]
          statusOptions.push(...this.options.filter((option) => option.value === 'cancelled'))
          break
        }
        case 'draft-sales-order': {
          statusOptions = [{ text: this.$t('draft-sales-order'), value: 'draft-sales-order' }]
          statusOptions.push(
            ...this.options.filter(
              (option) => option.value === 'cancelled' || option.value === 'sales-order'
            )
          )
          break
        }
        default: {
          statusOptions = this.options
        }
      }
      return statusOptions
    },
  },
  methods: {
    goBack() {
      this.$bvModal.hide(`change-trip-status-model${this?.id ? `-${this.id}` : ''}`)
    },
    Submit() {
      this.loading = true
      this.error = null

      const data = {}

      data['reservationId'] = this.$route.params.id || this.id
      if (this.selected) data['status'] = this.selected
      NewReservationService.post(data, 'change-reservation')
        .then((res) => {
          this.$emit('refreshData')
          if (res?.updatedReservation?.status === 'draft-sales-order') {
            this.$store.dispatch('enums/SHOW_TOASTER_POP', {
              message: this.$t('convert-status-draft-sales-order-message'),
              variant: 'success',
              title: this.$t('success'),
              duration: 10000,
              noCloseButton: false,
            })
          }
          this.$bvModal.hide(`change-trip-status-model${this?.id ? `-${this.id}` : ''}`)
          if (res?.noTrips) {
            this.$store.dispatch('enums/SHOW_TOASTER_POP', {
              message: this.$t('convert-status-message'),
              variant: 'warning',
              title: this.$t('warning'),
              duration: 10000,
              noCloseButton: false,
            })
          }
          this.loading = false
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeModel() {
      this.$bvModal.hide(`change-trip-status-model${this?.id ? `-${this.id}` : ''}`)
    },
  },
  created() {
    this.selected = this.status
    this.originSelectedStatus = this.status
  },
}
</script>

<style lang="scss" scoped>
.reservation-info {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--color-23);
}
.hr-border {
  height: 1px;
  background: var(--color-23);
  width: 100%;
  margin-top: 5px;
  margin-bottom: 15px;
}
.reservation-status-options {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--color-17);
}
</style>
